import { Suspense } from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import HomeScreen from '../pages/HomeScreen';
import Home from '../pages/Home';
import About from '../pages/About';
import Contact from "../pages/Contact";
import Authentication from '../pages/Authentication';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer, toast } from 'react-toastify';
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from 'react-redux';
import store from '../store/index'
import '../assets/css/style.css';


function App() {
  const queryClient=new QueryClient()
  return (
    
  <Provider store={store} >
    <QueryClientProvider client={queryClient}>
    <Suspense fallback={<div>Loading...</div>}>
<Routes>
  <Route path='/homescreen/*' element={<HomeScreen />}></Route>
  <Route path='/auth' element={<Authentication />}></Route>

  <Route path='/' element={<Home />}></Route>
  <Route path='/about' element={<About />}></Route>
  <Route path='/contact' element={<Contact />}></Route>
  
</Routes>
  
   </Suspense>
   <ToastContainer position='top-right' theme='dark'/>
   <ReactQueryDevtools initialIsOpen={false}></ReactQueryDevtools>
   </QueryClientProvider>
   </Provider>
  );
}

export default App;